import lodash from 'lodash';
import React, { useCallback, useMemo, useState } from 'react';
import Portal from 'components/Portal';
import { Fade } from 'components/Transition';
import classlist from 'utils/classlist';
import { TelcodesSelectionProps } from './PC';

const Mobile: React.FC<TelcodesSelectionProps> = ({ telcodes, value, onChange, isTel, countryValueKey }) => {
    const [visible, setVisible] = useState(false);
    const [searchKey, setSearchKey] = useState('');
    const hide = useCallback(() => {
        setVisible(false);
    }, []);
    const countryItems = useMemo(() => {
        return lodash.uniqBy(
            telcodes.reduce((ret, { items }) => {
                return ret.concat(items);
            }, [] as any[]),
            item => item[countryValueKey]
        );
    }, [telcodes, countryValueKey]);
    const filterItems = useMemo(() => {
        if (!searchKey) {
            return countryItems;
        }

        const tmpKey = searchKey.toLowerCase();

        return countryItems.filter(
            item =>
                item.tel_code?.toString().includes(tmpKey) ||
                // countryValueKey为tel_code时是数字
                item[countryValueKey]?.toString().toLowerCase().includes(tmpKey) ||
                item.country?.toLowerCase().includes(tmpKey)
        );
    }, [countryItems, searchKey, countryValueKey]);
    const activeRef = useCallback(elem => {
        if (elem) {
            setTimeout(() => {
                const rect = elem.getBoundingClientRect();

                elem.parentNode && (elem.parentNode.scrollTop = rect.top - 120);
            });
        }
    }, []);

    return (
        <>
            <Fade in={visible} timeout={400} onExited={() => setSearchKey('')}>
                <Portal>
                    <div className="telcode-mobile-selection">
                        <header className="search">
                            <input
                                autoFocus
                                type="search"
                                className="input"
                                value={searchKey}
                                onChange={ev => setSearchKey(ev.target.value.trim())}
                            />
                            <span className="cancel">
                                <button className="btn" onClick={hide}>
                                    {__('取消')}
                                </button>
                            </span>
                        </header>
                        <section className="country-list">
                            {filterItems.map(item => (
                                <div
                                    className={classlist('country-item', value === item[countryValueKey] && 'active')}
                                    ref={value === (isTel ? item.tel_code : item[countryValueKey]) ? activeRef : null}
                                    key={item[countryValueKey]}
                                    onClick={() => {
                                        onChange(item);
                                        hide();
                                    }}>
                                    {isTel
                                        ? `${item.country} +${item.tel_code}`
                                        : `${item.country} ${item[countryValueKey]}`}
                                </div>
                            ))}
                            {!filterItems.length && (
                                <div className="no-result">
                                    <h3>{__('未找到匹配的国家或地区')}</h3>
                                </div>
                            )}
                        </section>
                    </div>
                </Portal>
            </Fade>
            <div
                className={classlist('trigger', visible && 'is-visible')}
                onClick={ev => {
                    ev.stopPropagation();
                    setVisible(!visible);
                }}
                title={__('选择手机号所在地区')}>
                select
            </div>
        </>
    );
};

export default Mobile;
